import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { Row } from 'components/Containers/Row/Row';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import Label from 'components/form/Label/Label';
import { ProfileDataItem } from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import TwoFAEnabled from 'pages/Profile/pages/AccountSettings/components/TwoFAEnabled';
import TwoFADisabled from 'pages/Profile/pages/AccountSettings/components/TwoFADisabled';

const { Title, DisplayView } = ProfileDataItem;

const TwoFactorExpanded = props => {
  if (props.isTwoFactorEnabled) {
    return <TwoFAEnabled {...props} />;
  } else {
    return <TwoFADisabled {...props} />;
  }
};

const SecuritySection = props => {
  return (
    <SectionContainer className="emailPasswordSection">
      <Row>
        <TitleContainer
          className="loginSecurityTitle"
          data-testid="loginSecurityTitle"
        >
          <Label type="H3" typeHeader={'h3'}>
            Security
          </Label>
        </TitleContainer>
        <ProfileDataItem datatestid={`accountSettings-2fa`}>
          <Title>Two-Factor Authentication</Title>
          {!props.isTwoFactorExpanded && (
            <DisplayView
              datatestid={`displayView2FA`}
              editEnabled={!props.isTwoFactorEnabled}
              editHandle={props.toggleTwoFactorExpansion}
            >
              <Label datatestid={`readOnly2FA`}>
                {props.isTwoFactorEnabled ? 'Enabled' : 'Not Enabled'}
              </Label>
            </DisplayView>
          )}
          {props.isTwoFactorExpanded && <TwoFactorExpanded {...props} />}
        </ProfileDataItem>
      </Row>
    </SectionContainer>
  );
};

export default SecuritySection;
